/**
 * Mobile Mart - Facets Filter Handler
 * Handles Shopify native Search & Discovery filters
 */

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = this.debounce((e) => {
      this.onSubmitHandler(e);
    }, 400);

    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onSubmitHandler(e) {
    e.preventDefault();
    const form = this.querySelector('form');
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams);
  }

  onActiveFilterClick(e) {
    e.preventDefault();
    const url = e.currentTarget.href;
    this.renderPage(new URL(url).searchParams.toString());
  }

  async renderPage(searchParams) {
    const url = `${window.location.pathname}?${searchParams}`;
    window.history.pushState({ path: url }, '', url);

    try {
      const res = await fetch(url);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.getElementById('ProductGridContainer');
      const oldGrid = document.getElementById('ProductGridContainer');
      if (newGrid && oldGrid) {
        oldGrid.innerHTML = newGrid.innerHTML;
      }
    } catch (err) {
      console.error('Filter update error:', err);
      window.location.href = url;
    }
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);
